import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  viewBox: "0 0 8 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M0 7c0-.3.1-.5.3-.7l6-6c.4-.4 1-.4 1.4 0s.4 1 0 1.4L2.4 7l5.3 5.3c.4.4.4 1 0 1.4s-1 .4-1.4 0l-6-6C.1 7.5 0 7.3 0 7" }, null, -1)
  ])))
}
export default { render: render }